<form *ngIf="schemsForm">
    <div class="whole-modal">
        <div class="modal-header" *ngIf="mode == 'pop-up' && enableCloseIcon()">
            <div class="d-flex align-items-center justify-content-between w-100">
                <div class="d-flex align-items-center">
                    <h4 class="mb-0">
                        {{ pagetitle }}
                    </h4>
                </div>
                <div *ngIf="trail">
                    <div class="d-flex">
                        <div class="activity_title_wrapper d-flex align-items-center justify-content-end w-100">
                            <ng-container *ngIf="projectName">
                                <span class="activity_title">Project Name</span>
                                <span class="section-data">{{ projectName }}</span>
                            </ng-container>
                            <ng-container *ngIf="workpackName">
                                <span class="activity_title">Workpack Name</span>
                                <span class="section-data">{{ workpackName }}</span>
                            </ng-container>
                            <ng-container *ngIf="jointIdName">
                                <span class="activity_title">Joint ID</span>
                                <span class="section-data">{{ jointIdName }}</span>
                            </ng-container>
                            <!-- <ng-container *ngIf="activitypackTypeStatus">
                                <span class="activity_title">Status </span>
                                <span class="section-data">{{ activitypackTypeStatus }}</span>
                            </ng-container> -->
                        </div>
                    </div>
                </div>
                <div *ngIf="!trail">
                    <div class="d-flex">
                        <div class="activity_title_wrapper d-flex align-items-center justify-content-end w-100">
                            <ng-container *ngIf="projectName">
                                <span class="activity_title">Project Name</span>
                                <span class="section-data">{{ projectName }}</span>
                            </ng-container>
                            <ng-container *ngIf="workpackName">
                                <span class="activity_title">Workpack Name</span>
                                <span class="section-data">{{ workpackName }}</span>
                            </ng-container>
                            <ng-container *ngIf="jointIdName">
                                <span class="activity_title">Joint ID</span>
                                <span class="section-data">{{ jointIdName }}</span>
                            </ng-container>
                            <ng-container *ngIf="activitypackTypeStatus">
                                <span class="activity_title">Status </span>
                                <span class="section-data">{{ activitypackTypeStatus }}</span>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
            <a class="close-icon" href="javascript:void()" ngbAutofocus (click)="closeClick()">
                <i class="flaticon2-cross"></i>
            </a>
        </div>

        <div class="modal-body output-lable activity_body" *ngIf="jsonObjectCopy">
            <div class="inspection_form p-5">
                <div class="col-md-12 mt-5 aler_message_div" *ngIf="IsVersionUpgrade">
                    <div class="alert-custom-wrapper">
                        <span class="alertUpgrade">
                            <span
                                class="svg-icon svg-icon-primary svg-icon-2x"
                                title="{{ 'PLANT_MANAGER.ClickToUpgrade' | transloco }}"
                                (click)="upgradeToLatestSchema()"
                            >
                                <i class="mdi mdi-update"></i>
                            </span>
                            <span class="warning-text">
                                {{ 'PLANT_MANAGER.ThisItemHasNewANewSchemaVersion' | transloco }}
                                <b style="cursor: pointer" (click)="upgradeToLatestSchema()">{{ 'PLANT_MANAGER.Upgrade' | transloco }}</b>
                                {{ 'PLANT_MANAGER.toTheLatestSchemaVersionNow' | transloco }}
                            </span>
                        </span>

                        <!-- <i class="fa flaticon-close alert-error" aria-hidden="true" style=" margin-right: 8px;margin-top: 2px"> </i> -->
                    </div>
                </div>

                <ng-container *ngIf="jsonObjectCopy[0].type == 'section'">
                    <div
                        class="card custom-card"
                        *ngFor="let sec of jsonObjectCopy"
                        [ngClass]="{ 'grid-100': sec.groups.length === 1, 'grid-50': sec.groups.length !== 1 }"
                    >
                        <ng-container *ngFor="let group of sec.groups; let i = index">
                            <span class="group-wrapper">
                                <ng-container *ngFor="let item of group.fields">
                                    <ng-container
                                        *ngTemplateOutlet="Controls; context: { item: item, secKey: sec.key, groupName: group.key, i: i }"
                                    ></ng-container>
                                </ng-container>
                            </span>
                        </ng-container>
                    </div>
                </ng-container>

                <ng-container *ngIf="jsonObjectCopy[0].type == 'tab'">
                    <mat-tab-group (selectedTabChange)="onTabChange($event)" [(selectedIndex)]="selectedTabIndex" class="tab-wrapper">
                        <mat-tab label="{{ tab.alias }}" *ngFor="let tab of jsonObjectCopy; let i = index">
                            <div
                                class="card custom-card"
                                *ngFor="let sec of tab.sections; let j = index"
                                [ngClass]="{ 'grid-100': sec.groups.length === 1, 'grid-50': sec.groups.length !== 1 }"
                            >
                                <ng-container *ngFor="let group of sec.groups; let k = index">
                                    <div class="section-wrapper">
                                        <div *ngFor="let item of group.fields">
                                            <ng-container
                                                *ngTemplateOutlet="
                                                    Controls;
                                                    context: { item: item, secKey: sec.key, groupName: group.key, i: i, j: j, tabName: tab.key, k: k }
                                                "
                                            ></ng-container>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </mat-tab>
                    </mat-tab-group>
                </ng-container>
            </div>
        </div>

        <div class="modal-footer button-wrapper p-5">
            <p *ngIf="jointIdSetting?.abbreviation == 'Auto' && !this.JsonDataContent">
                * The Joint ID will be dynamically assigned to this joint when saving.
            </p>

            <button type="button" *ngIf="isSaveEnable && selectedTabIndex == 1" class="btn primary-ebtn me-3" (click)="backClick()">
                <div class="d-flex align-items-center">
                    <!-- <span class="svg-icon svg-icon-primary svg-icon-2x">
                        <svg
                            class="d-flex"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            width="24px"
                            height="24px"
                            viewBox="0 0 24 24"
                            version="1.1"
                        >
                            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <polygon points="0 0 24 0 24 24 0 24" />
                                <rect
                                    fill="#000000"
                                    opacity="0.3"
                                    transform="translate(12.000000, 12.000000) scale(-1, 1) rotate(-90.000000) translate(-12.000000, -12.000000) "
                                    x="11"
                                    y="5"
                                    width="2"
                                    height="14"
                                    rx="1"
                                />
                                <path
                                    d="M3.7071045,15.7071045 C3.3165802,16.0976288 2.68341522,16.0976288 2.29289093,15.7071045 C1.90236664,15.3165802 1.90236664,14.6834152 2.29289093,14.2928909 L8.29289093,8.29289093 C8.67146987,7.914312 9.28105631,7.90106637 9.67572234,8.26284357 L15.6757223,13.7628436 C16.0828413,14.136036 16.1103443,14.7686034 15.7371519,15.1757223 C15.3639594,15.5828413 14.7313921,15.6103443 14.3242731,15.2371519 L9.03007346,10.3841355 L3.7071045,15.7071045 Z"
                                    fill="#000000"
                                    fill-rule="nonzero"
                                    transform="translate(9.000001, 11.999997) scale(-1, -1) rotate(90.000000) translate(-9.000001, -11.999997) "
                                />
                            </g>
                        </svg>
                    </span> -->
                    Back
                </div>
            </button>

            <button type="button" style="position: relative" class="btn secondary-ebtn me-3" *ngIf="showBtnCancel()" (click)="cancelClick()">Cancel</button>
            <app-print-reports
                class="me-3"
                *ngIf="(showPrint && IsPlantManangerPage) || isWorkPackPage"
                [calculationResult]="calcResult"
                [TaggedItemData]="TaggedItemData"
                [barCodeNumber]="barCodeNumber"
                [Type]="'1'"
                [activityPackDetails]="activityPackDetails"
            ></app-print-reports>

            <div class="mt-4 mb-4 aler_message_div" *ngIf="IsLeakOrExceptionVersionUpgrade" style="position: absolute; left: 0">
                <div class="alert-custom-wrapper">
                    <span class="alertUpgrade">
                        <span
                            class="svg-icon svg-icon-primary svg-icon-2x"
                            title="{{ 'PLANT_MANAGER.ClickToUpgrade' | transloco }}"
                            style="cursor: pointer"
                            (click)="upgradeToLatestSchema()"
                        >
                            <i class="mdi mdi-update"></i>
                            <!--end::Svg Icon-->
                        </span>
                        <span class="warning-text">
                            {{ 'PLANT_MANAGER.ThisItemHasNewANewSchemaVersion' | transloco
                            }}<b style="cursor: pointer" (click)="upgradeToLatestSchema()">{{ 'PLANT_MANAGER.Upgrade' | transloco }}</b>
                            {{ 'PLANT_MANAGER.toTheLatestSchemaVersionNow' | transloco }}
                        </span>
                    </span>
                </div>
            </div>

            <!-- <button type="button" class="btn secondary-ebtn" (click)="consoleForm()">form</button> -->
 
            <button
                type="button" *ngIf="isSaveEnable && permission"               
                [disabled]="!(schemsForm.valid && (schemsForm.dirty || IsVersionUpgradeData()))"
                class="btn primary-ebtn"
                (click)="submitItem()"
            >
                {{ SaveText }}
            </button>

            <button type="button" *ngIf="!isSaveEnable" class="btn primary-ebtn" (click)="nextClick()">
                <div class="d-flex align-items-center">
                    Next
                    <!-- <span class="svg-icon svg-icon-primary svg-icon-2x"
                        ><svg
                            class="d-flex"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            width="18px"
                            height="18px"
                            viewBox="0 0 24 24"
                            version="1.1"
                        >
                            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <polygon points="0 0 24 0 24 24 0 24" />
                                <rect
                                    fill="#000000"
                                    opacity="0.3"
                                    transform="translate(8.500000, 12.000000) rotate(-90.000000) translate(-8.500000, -12.000000) "
                                    x="7.5"
                                    y="7.5"
                                    width="2"
                                    height="9"
                                    rx="1"
                                />
                                <path
                                    d="M9.70710318,15.7071045 C9.31657888,16.0976288 8.68341391,16.0976288 8.29288961,15.7071045 C7.90236532,15.3165802 7.90236532,14.6834152 8.29288961,14.2928909 L14.2928896,8.29289093 C14.6714686,7.914312 15.281055,7.90106637 15.675721,8.26284357 L21.675721,13.7628436 C22.08284,14.136036 22.1103429,14.7686034 21.7371505,15.1757223 C21.3639581,15.5828413 20.7313908,15.6103443 20.3242718,15.2371519 L15.0300721,10.3841355 L9.70710318,15.7071045 Z"
                                    fill="#000000"
                                    fill-rule="nonzero"
                                    transform="translate(14.999999, 11.999997) scale(1, -1) rotate(90.000000) translate(-14.999999, -11.999997) "
                                />
                            </g>
                        </svg>
                    </span> -->
                </div>
            </button>

            <button type="button" class="btn primary-ebtn" *ngIf="showJointtighteningBtn == true" (click)="showJointtightening()">
                Update Tightening Details
            </button>
        </div>
    </div>
</form>

<ng-template #Controls let-item="item" let-groupName="groupName" let-secKey="secKey" let-i="i" let-tabName="tabName" let-j="j" let-k="k">
    <div *ngIf="getGroup(secKey, groupName, i, tabName, j, k)" [formGroup]="getGroup(secKey, groupName, i, tabName, j, k)">
        <ng-container *ngIf="item && item?.key">
            <!-- <pre>{{secKey}}</pre> -->
            <div [ngSwitch]="item?.type">
                <div class="control-wrapper" *ngSwitchCase="controlTypes.TextBox">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="label-wrap">
                                <mat-label class="font-style">{{ item.alias }}</mat-label>
                            </div>
                        </div>
                        <div class="col-md-8">                        
                            <input
                                type="text"
                                class="input-form-class"
                                matInput
                                name="{{ item.key }}"
                                [placeholder]="item.Placeholder"
                                [mask]="item.maskValue"
                                [formControlName]="item.key"
                                [showMaskTyped]="true"
                                [class.disable]="permission != true || AdditionalInfo?.ActivityPackStatus == 'Complete'"
                                [ngClass]="checkControl(item.key, secKey, groupName, i, tabName, j, k).valid ? '' : 'highLight'"
                                (keypress)="handleInputEvent($event, 'AllowUnderscoreHypen')"
                                (paste)="handleInputEvent($event, 'AllowUnderscoreHypen')"
                            />
                            <ng-container *ngIf="checkControl(item.key, secKey, groupName, i, tabName, j, k)?.invalid">
                                <div *ngFor="let val of item.validators">
                                    <p class="error-message" *ngIf="checkControl(item.key, secKey, groupName, i, tabName, j, k).hasError(val.key)">
                                        {{ val.message }}
                                    </p>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>

                <div class="control-wrapper" *ngSwitchCase="controlTypes.TextArea">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="label-wrap">
                                <mat-label class="font-style">{{ item.alias }}</mat-label>
                            </div>
                        </div>
                        <div class="col-md-8">                            
                            <textarea
                                rows="4"
                                class="input-form-class"
                                type="text"
                                matInput
                                [formControlName]="item.key"
                                [class.disable]="permission != true || AdditionalInfo?.ActivityPackStatus == 'Complete'"
                                [ngClass]="checkControl(item.key, secKey, groupName, i, tabName, j, k).valid ? '' : 'highLight'"
                                (keypress)="handleInputEvent($event, 'AllowUnderscoreHypen')"
                                (paste)="handleInputEvent($event, 'AllowUnderscoreHypen')"
                            ></textarea>
                            <ng-container *ngIf="checkControl(item.key, secKey, groupName, i, tabName, j, k).invalid">
                                <div *ngFor="let val of item.validators">
                                    <p class="error-message" *ngIf="checkControl(item.key, secKey, groupName, i, tabName, j, k).hasError(val.key)">
                                        {{ val.message }}
                                    </p>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>

                <div class="control-wrapper" *ngSwitchCase="controlTypes.Select">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="label-wrap">
                                <mat-label class="font-style">{{ item.alias }}</mat-label>
                            </div>
                        </div>
                        <div class="col-md-8">
                            <mat-select
                                class="input-select"
                                panelClass="input-select"
                                [formControlName]="item.key"
                                [class.disable]="permission != true || AdditionalInfo?.ActivityPackStatus == 'Complete'"
                                [ngClass]="checkControl(item.key, secKey, groupName, i, tabName, j, k).valid ? '' : 'highLight'"
                            >
                                <mat-option class="option-list" *ngFor="let s of item.selections" [value]="s">{{ s }}</mat-option>
                            </mat-select>
                            <ng-container *ngIf="checkControl(item.key, secKey, groupName, i, tabName, j, k).invalid">
                                <div *ngFor="let val of item.validators">
                                    <p class="error-message" *ngIf="checkControl(item.key, secKey, groupName, i, tabName, j, k).hasError(val.key)">
                                        {{ val.message }}
                                    </p>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>

                <div class="control-wrapper" *ngSwitchCase="controlTypes.RadioButtonList">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="label-wrap">
                                <mat-label class="font-style">{{ item.alias }}</mat-label>
                            </div>
                        </div>
                        <div class="col-md-8">
                            <mat-radio-group
                                [formControlName]="item.key"
                                name="{{ item.key }}"
                                aria-labelledby="example-radio-group-label"
                                class="example-radio-group"
                            >
                                <mat-radio-button
                                    [class.disable]="permission != true || AdditionalInfo?.ActivityPackStatus == 'Complete'"
                                    class="example-radio-button radio-wrapper"
                                    *ngFor="let s of item.selections"
                                    [value]="s"
                                >
                                    {{ s }}
                                </mat-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                </div>

                <div class="control-wrapper" *ngSwitchCase="controlTypes.Display">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="label-wrap">
                                <mat-label class="font-style">{{ item.alias }}</mat-label>
                            </div>
                        </div>
                        <div class="col-md-8">
                            <input
                                type="text"
                                class="input-form-class"
                                matInput
                                name="{{ item.key }}"
                                [class.disable]="permission != true || AdditionalInfo?.ActivityPackStatus == 'Complete'"
                                [ngClass]="checkControl(item.key, secKey, groupName, i, tabName, j, k).valid ? '' : 'highLight'"
                                [placeholder]="item.Placeholder"
                                [formControlName]="item.key"
                                readonly
                            />
                        </div>
                    </div>
                </div>

                <div class="control-wrapper" *ngSwitchCase="controlTypes.Date">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="label-wrap">
                                <mat-label class="font-style">{{ item.alias }}</mat-label>
                            </div>
                        </div>
                        <div class="col-md-8">                             
                            <dx-date-box
                                class="dx-date-custom-wrapper dx-date-custom-outlined"
                                displayFormat="dd-MMM-yyyy"
                                [inputAttr]="{ 'aria-label': 'Choose Date' }"
                                [formControlName]="item?.key"
                                [class.disable]="permission != true || AdditionalInfo?.ActivityPackStatus == 'Complete'"
                                [ngClass]="checkControl(item.key, secKey, groupName, i, tabName, j, k).valid ? '' : 'highLight'"
                                blockDateTyping
                            >
                            </dx-date-box>
                            <!-- Added 'blockDateTyping' directive to block typing  in dx-datepicker -->

                            <ng-container *ngIf="checkControl(item.key, secKey, groupName, i, tabName, j, k).invalid">
                                <div *ngFor="let val of item.validators">
                                    <p class="error-message" *ngIf="checkControl(item.key, secKey, groupName, i, tabName, j, k).hasError(val.key)">
                                        {{ val.message }}
                                    </p>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="getGroup(secKey, groupName, i, tabName, j, k)?.errors?.['dateComparison'] && item.datetype == 'startdate'">
                                <p class="error-message">Start date should be always lesser than the End date!!</p>
                            </ng-container>
                            <ng-container *ngIf="getGroup(secKey, groupName, i, tabName, j, k)?.errors?.['dateComparison'] && item.datetype == 'enddate'">
                                <p class="error-message">End date should be always greater then the Start date!</p>
                            </ng-container>
                        </div>
                    </div>
                </div>

                <div class="control-wrapper" *ngSwitchCase="controlTypes.Checkbox">
                    <div class="row">
                        <div class="col-md-4">
                            {{ item.alias }}
                        </div>
                        <div class="col-md-8">
                            <mat-checkbox
                                class="checkbox-wrap"
                                [class.disable]="permission != true || AdditionalInfo?.ActivityPackStatus == 'Complete'"
                                [formControlName]="item.key"
                            ></mat-checkbox>
                            <!-- style="margin-top: 20px; padding-left: 16px" -->
                            <ng-container *ngIf="checkControl(item.key, secKey, groupName, i, tabName, j, k).value != true && item.validators">
                                <div *ngFor="let val of item.validators">
                                    <p class="error-message" *ngIf="checkControl(item.key, secKey, groupName, i, tabName, j, k).value != val.value">
                                        {{ val.message }}
                                    </p>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>

                <div class="control-wrapper" *ngSwitchCase="controlTypes.CheckBoxList">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="label-wrap">
                                <mat-label class="font-style">{{ item.alias }}</mat-label>
                            </div>
                        </div>
                        <div class="col-md-8">
                        
                            <mat-selection-list
                                [formControlName]="item.key"
                                class="custom-mat-list selection-list"
                                [class.disable]="permission != true || AdditionalInfo?.ActivityPackStatus == 'Complete'"
                                (selectionChange)="onCheckboxListChange($event, item.key)"
                            >
                                <mat-list-option *ngFor="let s of item.selections" [value]="s" checkboxPosition="before">
                                    {{ s }}
                                </mat-list-option>
                            </mat-selection-list>
                        </div>
                    </div>
                </div>

                <div class="control-wrapper measurement-wrapper" *ngSwitchCase="controlTypes.MeasurementUnit">
                    <div class="row" *ngIf="checkControl(item.key, secKey, groupName, i, tabName, j, k)">
                        <div class="col-md-4">
                            <mat-label class="font-style measurement-label">{{ item.alias }}</mat-label>
                        </div>
                        <div class="col-md-8">
                            <div class="row" [formGroup]="checkControl(item.key, secKey, groupName, i, tabName, j, k)">
                                <div class="col-md-8">
                                    <input
                                        type="number"
                                        class="input-form-class measurement-input"
                                        matInput
                                        formControlName="value"
                                        [class.disable]="permission != true || AdditionalInfo?.ActivityPackStatus == 'Complete'"
                                        (change)="measurentValueChange($event, item, schemsForm.get(secKey).controls[i].get(groupName).get(item.key))"
                                    />
                                </div>

                                <div class="col-md-4">
                                    <mat-select
                                        class="input-select"
                                        panelClass="input-select"
                                        formControlName="unit"
                                        [class.disable]="permission != true || AdditionalInfo?.ActivityPackStatus == 'Complete'"
                                        style="padding: 10px 10px; height: 38px"
                                        (selectionChange)="measurentValueChange($event, item, schemsForm.get(secKey).controls[i].get(groupName).get(item.key))"
                                    >
                                        <mat-option class="option-list" *ngFor="let result of item?.DisplayUnit" [value]="result.key">{{
                                            result.key
                                        }}</mat-option>
                                    </mat-select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <ng-container>
                    <div class="control-wrapper" *ngSwitchCase="controlTypes.DBSelect">
                        <div class="row" *ngIf="checkControl(item.key, secKey, groupName, i, tabName, j, k)">
                            <div class="col-md-4">
                                <div class="label-wrap">
                                    <mat-label class="font-style">{{ item.alias }}</mat-label>
                                </div>
                            </div>
                            <div class="col-md-8">
                                <mat-select
                                    class="input-select"
                                    panelClass="dropdown-wrapper"
                                    [formControlName]="item.key"
                                    [class.disable]="permission != true || AdditionalInfo?.ActivityPackStatus == 'Complete'"
                                    [ngClass]="checkControl(item.key, secKey, groupName, i, tabName, j, k).valid ? '' : 'highLight'"
                                >
                                    <ng-container *ngIf="item.selections.length > 0; else noData">
                                        <mat-option class="option-list" *ngFor="let db of item.selections" [value]="db.databaseSelectValueId">{{
                                            db.name
                                        }}</mat-option>
                                    </ng-container>
                                    <ng-template #noData style="color: gray">
                                        <mat-option style="color: gray" class="option-list textcolor" [value]="''" disabled>
                                            No data available to display, please contact the administrator
                                        </mat-option>
                                    </ng-template>
                                </mat-select>
                                <ng-container *ngIf="checkControl(item.key, secKey, groupName, i, tabName, j, k).invalid">
                                    <div *ngFor="let val of item.validators">
                                        <p class="error-message" *ngIf="checkControl(item.key, secKey, groupName, i, tabName, j, k).hasError(val.key)">
                                            {{ val.message }}
                                        </p>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </ng-container>

                <ng-container *ngIf="getGroup(secKey, groupName, i, tabName, j, k).get(linenumberControlname)">

                   
                    <div *ngSwitchCase="controlTypes.LineNumber">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="label-wrap">
                                    <mat-label class="font-style">{{ item.alias[0] }}</mat-label>
                                </div>
                            </div>
                            <div class="col-md-8">
                                <mat-select
                                    formControlName="linenumber_selection"
                                    class="input-select"
                                    panelClass="input-select"
                                    (selectionChange)="LineFormatChange($event, item, secKey, groupName, i, tabName, j)"
                                >
                                    <mat-option class="option-list" *ngFor="let l of lineNumberFormet" [value]="l.lineNumberFormatId">{{ l.name }}</mat-option>
                                </mat-select>
                            </div>
                        </div>

                        <div class="row mt-4">
                            <div class="col-md-4">
                                <div class="label-wrap">
                                    <mat-label class="font-style">{{ item.alias[1] }}</mat-label>
                                </div>
                            </div>

                            <div class="col-md-8">
                                <div class="example-part" *ngIf="!selectedLineNumberFormate.allowFreeForm">
                                    <div class="example-wrapper">
                                        <div
                                            class="wrapper-box"
                                            *ngFor="let ex of lineNumberFormetSection; let j = index"
                                            [formGroup]="getGroup(secKey, groupName, i, tabName, j, k).get(linenumberControlname).controls[j]"
                                        >
                                            <mat-form-field class="example-full-width line-divider" style="width: 95px; float: left">
                                                <input
                                                    type="text"
                                                    formControlName="value"
                                                    matInput
                                                    [class.disable]="permission != true || AdditionalInfo?.ActivityPackStatus == 'Complete'"
                                                    (keypress)="handleInputEvent($event, 'AllowUnderscoreHypen')"
                                                    (paste)="handleInputEvent($event, 'AllowUnderscoreHypen')"
                                                />
                                            </mat-form-field>

                                            <span class="span-text">{{ ex.name }}</span>
                                            <div class="error-wrapper">
                                                <p
                                                    class="error-message"
                                                    *ngIf="
                                                        getGroup(secKey, groupName, i, tabName, j, k)
                                                            .get(linenumberControlname)
                                                            ?.controls[j]?.get('value')
                                                            ?.hasError('minlength')
                                                    "
                                                >
                                                    {{ 'PLANT_MANAGER.MinLengthIs' | transloco }} {{ ex.minLength }}.
                                                </p>

                                                <p
                                                    class="error-message"
                                                    *ngIf="
                                                        getGroup(secKey, groupName, i, tabName, j, k)
                                                            .get(linenumberControlname)
                                                            .controls[j]?.get('value')
                                                            ?.hasError('maxlength')
                                                    "
                                                >
                                                    {{ 'PLANT_MANAGER.MaxLengthIs' | transloco }} {{ ex.maxLength }}.
                                                </p>

                                                <p
                                                    class="error-message"
                                                    *ngIf="
                                                        getGroup(secKey, groupName, i, tabName, j, k).get(linenumberControlname)?.controls[j]?.get('value')?.errors
                                                            ?.pattern?.requiredPattern === '^[a-zA-Z]+$'
                                                    "
                                                >
                                                    {{ 'PLANT_MANAGER.AlwaysEnterAlphabetic' | transloco }}
                                                </p>

                                                <p
                                                    class="error-message"
                                                    *ngIf="
                                                        getGroup(secKey, groupName, i, tabName, j, k).get(linenumberControlname)?.controls[j]?.get('value')?.errors
                                                            ?.pattern?.requiredPattern === '^[0-9]+$'
                                                    "
                                                >
                                                    {{ 'PLANT_MANAGER.AlwaysEnterNumeric' | transloco }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    class="example-full-width"
                                    style="width: 100%"
                                    *ngIf="
                                        selectedLineNumberFormate?.allowFreeForm && getGroup(secKey, groupName, i, tabName, j, k).get(linenumberControlname).controls[0]
                                    "
                                    [formGroup]="getGroup(secKey, groupName, i, tabName, j, k).get(linenumberControlname).controls[0]"
                                >
                                    <input
                                        type="text"
                                        class="input-form-class"
                                        formControlName="value"
                                        matInput
                                        (keypress)="handleInputEvent($event, 'AllowUnderscoreHypen')"
                                        (paste)="handleInputEvent($event, 'AllowUnderscoreHypen')"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>

                <ng-container *ngSwitchCase="controlTypes?.jointcalculation">
                    <div class="control-wrapper">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="label-wrap">
                                    <mat-label class="font-style">{{ item.alias[0] }}</mat-label>
                                </div>
                            </div>
                            <div class="col-md-8">
                                <mat-select
                                    [disabled]="disable"
                                    class="input-select input-select"
                                    panelClass="input-select"
                                    [class.spinner]="loading"
                                    [formControlName]="item.key"
                                    (selectionChange)="CalculationtypeChanged($event)"
                                    [class.disable]="permission != true || AdditionalInfo?.ActivityPackStatus == 'Complete'"
                                >
                                    <mat-option value="0" class="option-list"> {{ 'PLANT_MANAGER.STANDARD_FLANGE' | transloco }}</mat-option>
                                    <mat-option value="1" class="option-list"> {{ 'PLANT_MANAGER.CUSTOM_FLANGE' | transloco }}</mat-option>
                                    <mat-option value="2" class="option-list"> {{ 'PLANT_MANAGER.CLAMP' | transloco }}</mat-option>
                                    <mat-option value="3" class="option-list"> {{ 'PLANT_MANAGER.ENGINEERED_JOINT' | transloco }}</mat-option>
                                </mat-select>
                                <button
                                    [disabled]="calcType == -1 || isjointcalcOpen"
                                    (click)="OpenJointCalcModel()"
                                    class="btn primary-ebtn mt-3 btn-full-width"
                                >
                                    {{ item.alias[1] }}
                                </button>
                            </div>
                        </div>
                    </div>
                </ng-container>

                <div class="control-wrapper" *ngSwitchCase="controlTypes.ImageUpload">
                    <!-- <pre>{{item|json}}</pre> -->
                    <ng-container *ngIf="item.imageoption == 'carousel'">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="label-wrap">
                                    <mat-label class="font-style">{{ item.alias }}</mat-label>
                                </div>
                            </div>
                            <div class="col-md-8">
                                <div class="addLibrary_body twoupload">
                                    <ng-container>
                                        <div>
                                            <!-- [class.disable]="permission != true || AdditionalInfo?.ActivityPackStatus == 'Complete'" -->
                                            <div class="custom-file">
                                                <input
                                                    type="file"
                                                    accept=".jpeg, .jpg, .png, .webp"
                                                    class="custom-file-input"
                                                    id="inputGroupFile01"
                                                    multiple="multiple"
                                                    (change)="fileChangeEvent($event)"
                                                    aria-describedby="inputGroupFileAddon01"
                                                    [disabled]="permission != true || AdditionalInfo?.ActivityPackStatus == 'Complete'"
                                                />
                                                <label class="custom-file-label" for="inputGroupFile01">
                                                    {{ 'PLANT_MANAGER.Choose_file' | transloco }}
                                                </label>
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="carousel-wrapper" style="margin: 10px 0" *ngIf="images.length">
                                    <!-- <pre>{{images|json}}</pre> -->
                                    <ngb-carousel [showNavigationArrows]="images.length > 1">
                                        <ng-template ngbSlide *ngFor="let item of images; let i = index">
                                            <div class="carousel-edit-wrapper">
                                                <button class="carousel-edit-button" mat-icon-button (click)="editImages(i)">
                                                    <mat-icon>edit</mat-icon>
                                                </button>
                                                <!-- <button mat-icon-button [matMenuTriggerFor]="menu"
                                                    aria-label="Example icon-button with a menu"
                                                    [class.disable]="permission != true || AdditionalInfo?.ActivityPackStatus == 'Complete'">
                                                    <mat-icon>more_vert</mat-icon>
                                                </button> -->
                                                <!-- <mat-menu #menu="matMenu">
                                                    <button mat-menu-item (click)="editImages(i)">
                                                        <mat-icon>edit</mat-icon>
                                                        <span>{{ 'PLANT_MANAGER.Edit' | transloco }}</span>
                                                    </button>
                                                    <button mat-menu-item (click)="deleteImage(i)">
                                                        <mat-icon>delete</mat-icon>
                                                        <span>{{ 'PLANT_MANAGER.Delete' | transloco }}</span>
                                                    </button>
                                                </mat-menu> -->
                                            </div>
                                            <div class="carousel-img-wrap">
                                                <img [src]="item.url" class="carousel-img" />
                                            </div>
                                            <input
                                                #fileInput
                                                id="fileInput"
                                                (change)="handleFileSelect($event, i)"
                                                accept="image/*"
                                                type="file"
                                                style="display: none"
                                                [class.disable]="permission != true"
                                            />
                                        </ng-template>
                                    </ngb-carousel>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="item.imageoption == 'logo'">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="label-wrap">
                                    <mat-label class="font-style">{{ item.alias }}</mat-label>
                                </div>
                            </div>
                            <div class="col-md-8">
                                <div class="profile_label">
                                    <div class="project-logo-wrapper">
                                        <span
                                            *ngIf="imageUrl == null"
                                            class="mdi mdi-image-search profile-image-instance"
                                            id="profile_image_instance"
                                            (click)="imageUpload.click()"
                                        ></span>
                                        <img
                                            *ngIf="imageUrl != null"
                                            [src]="imageUrl"
                                            class="profile-image"
                                            id="profile_image_instance"
                                            (click)="imageUpload.click()"
                                        />
                                        <div class="icon-wrapper">
                                            <div class="edit-icon" (click)="imageUpload.click()">
                                                <mat-icon>edit</mat-icon>
                                            </div>
                                            <div class="delete-icon" *ngIf="imageUrl != null">
                                                <mat-icon (click)="deleteLogoImg()">delete</mat-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br />
                            <!-- Use a hidden input element -->
                            <input id="imageUpload" accept="image/*" type="file" (change)="onSelectFile($event)" style="display: none" #imageUpload />
                        </div>
                    </ng-container>
                </div>

                <div class="control-wrapper" *ngSwitchCase="controlTypes.userselect">
                    <div class="row" *ngIf="item.userListCopy">
                        <div class="col-md-4">
                            <div class="label-wrap">
                                <mat-label class="font-style">{{ item.key }}</mat-label>
                            </div>
                        </div>
                        <div class="col-md-8">
                            <mat-form-field
                                class="example-full-width searchWrapper text-field-wrapper"
                                [ngClass]="checkControl(item.key, secKey, groupName, i, tabName, j, k).valid ? '' : 'highLight'"
                            >
                                <input
                                    type="text"
                                    [formControlName]="item.key"
                                    matInput
                                    [matAutocomplete]="auto"
                                    (keyup)="searchResult($event, item)"
                                    [class.disable]="permission != true || AdditionalInfo?.ActivityPackStatus == 'Complete'"
                                    (keypress)="handleInputEvent($event, 'AllowUnderscoreHypen')"
                                    (paste)="handleInputEvent($event, 'AllowUnderscoreHypen')"
                                />
                                <button mat-button matPrefix mat-icon-button class="search_btn">
                                    <mat-icon class="serach_icon">search</mat-icon>
                                </button>
                                <mat-autocomplete
                                    class="selectWrapper"
                                    panelClass="dropdown-wrapper test"
                                    autoActiveFirstOption
                                    #auto="matAutocomplete"
                                    [displayWith]="displayFn"
                                >
                                    <ng-container *ngIf="item.userList.length && checkControl(item.key, secKey, groupName, i, tabName, j, k)?.value">
                                        <mat-option class="option-list" *ngFor="let option of item.userList" [value]="option">
                                            {{ option?.fullName }}
                                        </mat-option>
                                    </ng-container>
                                </mat-autocomplete>
                            </mat-form-field>
                            <ng-container *ngIf="checkControl(item.key, secKey, groupName, i, tabName, j, k)?.invalid">
                                <p class="error-message" *ngIf="checkControl(item.key, secKey, groupName, i, tabName, j, k).hasError('userSelectionInvalid')">
                                    Please, select valid user!
                                </p>
                            </ng-container>
                        </div>
                    </div>
                </div>

                <div class="control-wrapper" *ngSwitchCase="controlTypes.circularslider">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="label-wrap">
                                <mat-label class="font-style">{{ item.alias }}</mat-label>
                            </div>
                        </div>
                        <div class="col-md-8">
                            <div id="gauge-demo">
                                <div id="gauge-container">
                                    <div class="center-section">
                                        <dx-circular-gauge [(value)]="speedValue" centerTemplate="centerTemplate">
                                            <dxo-size [width]="200" [height]="200"></dxo-size>
                                            <dxo-value-indicator [indentFromCenter]="20" [color]="color" [spindleSize]="0" [spindleGapSize]="0">
                                            </dxo-value-indicator>
                                            <dxo-geometry [startAngle]="90" [endAngle]="90"> </dxo-geometry>
                                            <dxo-scale [startValue]="0" [endValue]="360"> </dxo-scale>
                                            <svg *dxTemplate="let gauge of 'centerTemplate'">
                                                <circle cx="100" cy="100" r="55" [attr.stroke]="color" stroke-width="2" fill="transparent"></circle>
                                                <text
                                                    text-anchor="middle"
                                                    y="100"
                                                    x="100"
                                                    font-size="20"
                                                    font-weight="lighter"
                                                    alignment-baseline="middle"
                                                    [attr.fill]="color"
                                                >
                                                    {{ gauge.value() }}&deg;
                                                </text>
                                            </svg>
                                        </dx-circular-gauge>
                                    </div>
                                    <dx-slider
                                        id="slider"
                                        #sliderRef
                                        [class.disable]="permission != true || AdditionalInfo?.ActivityPackStatus == 'Complete'"
                                        [min]="0"
                                        [max]="360"
                                        [width]="50"
                                        [(value)]="speedValue"
                                        [formControlName]="item.key"
                                    >
                                        <dxo-tooltip [enabled]="true" [format]="format" showMode="always" position="bottom"></dxo-tooltip>
                                    </dx-slider>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="control-wrapper" *ngSwitchCase="controlTypes.alignment">
                    <ng-container>
                        <div class="row" [formGroup]="checkControl(item.key, secKey, groupName, i, tabName, j, k)">
                            <div class="col-md-1">
                                <div class="label-wrap">
                                    <mat-label class="font-style">{{ item.alias }}</mat-label>
                                </div>
                            </div>
                            <div class="col-md-11">
                                <div class="row">
                                    <div class="col-md-12 mt-4">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <mat-checkbox class="checkbox-wrap" formControlName="studboltsreplaced">Stud Bolts Replaced?</mat-checkbox>
                                            </div>
                                            <div class="col-lg-3">
                                                <mat-checkbox class="checkbox-wrap" formControlName="gasketreplaced">Gasket Replaced?</mat-checkbox>
                                            </div>
                                            <div class="col-lg-3">
                                                <mat-checkbox class="checkbox-wrap" formControlName="flangefacerepairrequired"
                                                    >Flange Face Repair Required?
                                                </mat-checkbox>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <mat-checkbox class="checkbox-wrap" formControlName="paintundernutremoved"
                                                    >Paint Under Nut Removed?</mat-checkbox
                                                >
                                            </div>
                                            <div class="col-lg-3">
                                                <mat-checkbox class="checkbox-wrap" formControlName="correctstud">Correct Stud?</mat-checkbox>
                                            </div>
                                            <div class="col-lg-3">
                                                <mat-checkbox class="checkbox-wrap" formControlName="studscorrectlylubricated"
                                                    >Studs Correctly Lubricated?</mat-checkbox
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-12 mt-2">
                                        <div class="row tablepad" *ngIf="checkControl(item.key, secKey, groupName, i, tabName, j, k).get('datalist').controls">
                                            <div
                                                class="col-lg-3 col-sm-6 pr-2 pl-2 mt-2"
                                                *ngFor="
                                                    let item of checkControl(item.key, secKey, groupName, i, tabName, j, k).get('datalist').controls;
                                                    let i = index
                                                "
                                            >
                                                <div class="activity_img_wrap">
                                                    <h4>{{ item.get('name').value }}</h4>
                                                    <div class="images_box">
                                                        <img *ngIf="i == 0" src="./../../../../assets/media/logos/centerline-1.png" alt="" />
                                                        <img *ngIf="i == 1" src="../../../../../assets/media/logos/seperation-1.png" alt="" />
                                                        <img *ngIf="i == 2" src="../../../../../assets/media/logos/gap-1.png" alt="" />
                                                        <img *ngIf="i == 3" src="../../../../../assets/media/logos/rotation-1.png" alt="" />
                                                    </div>
                                                    <div class="table-responsive custom-alignment-wrapper">
                                                        <table>
                                                            <tr>
                                                                <th>0 Drg</th>
                                                                <td>
                                                                    <mat-form-field class="input-field-wrapper custom-text-field" style="margin-top: 0px">
                                                                        <input
                                                                            type="text"
                                                                            matInput
                                                                            [formControl]="item.get('zerodrg')"
                                                                            (keypress)="handleInputEvent($event, 'AllowUnderscoreHypen')"
                                                                            (paste)="handleInputEvent($event, 'AllowUnderscoreHypen')"
                                                                        />
                                                                    </mat-form-field>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <th>90 Drg</th>
                                                                <td>
                                                                    <mat-form-field class="input-field-wrapper custom-text-field" style="margin-top: 0px">
                                                                        <input
                                                                            type="text"
                                                                            matInput
                                                                            [formControl]="item.get('ninetydrg')"
                                                                            (keypress)="handleInputEvent($event, 'AllowUnderscoreHypen')"
                                                                            (paste)="handleInputEvent($event, 'AllowUnderscoreHypen')"
                                                                        />
                                                                    </mat-form-field>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <th>180 Drg</th>
                                                                <td>
                                                                    <mat-form-field class="input-field-wrapper custom-text-field" style="margin-top: 0px">
                                                                        <input
                                                                            type="text"
                                                                            matInput
                                                                            [formControl]="item.get('oneeightydrg')"
                                                                            (keypress)="handleInputEvent($event, 'AllowUnderscoreHypen')"
                                                                            (paste)="handleInputEvent($event, 'AllowUnderscoreHypen')"
                                                                        />
                                                                    </mat-form-field>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <th>270 Drg</th>
                                                                <td>
                                                                    <mat-form-field class="input-field-wrapper custom-text-field" style="margin-top: 0px">
                                                                        <input
                                                                            type="text"
                                                                            matInput
                                                                            [formControl]="item.get('twoseventydrg')"
                                                                            (keypress)="handleInputEvent($event, 'AllowUnderscoreHypen')"
                                                                            (paste)="handleInputEvent($event, 'AllowUnderscoreHypen')"
                                                                        />
                                                                    </mat-form-field>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>

                <div class="control-wrapper" *ngSwitchCase="controlTypes.tighteningdetails">
                    <ng-container *ngIf="isJointCalculationAvailable && calcResult?.calculationSucceeded">
                        <ng-container *ngIf="checkControl(item.key, secKey, groupName, i, tabName, j, k)">
                            <div [formGroup]="checkControl(item.key, secKey, groupName, i, tabName, j, k)">
                                <div class="row mb-3" *ngIf="checkControl(item.key, secKey, groupName, i, tabName, j, k).get('tighteningmethod')">
                                    <div class="col-md-4">
                                        <div class="label-wrap">
                                            <mat-label class="font-style" placement="right" container="body" tooltipClass="custom-tooltip">
                                                {{ 'STANDARD_FLANGE_PAGE.LABELS.CALC_INPUT.METHOD' | transloco }}
                                                <!-- {{ checkControl(item.key, secKey, groupName, i, tabName, j, k).get('tighteningMethod').value }} -->
                                            </mat-label>
                                        </div>
                                    </div>
                                    <div class="col-md-8 method-select-btn">
                                        <div class="btn-group custom-toggle-wrap" role="group" [class.disable-div]="true">
                                            <label
                                                *ngFor="let opt of stateOptions"
                                                class="btn custom-toggle"
                                                [class.active]="
                                                    opt.value === checkControl(item.key, secKey, groupName, i, tabName, j, k).get('tighteningmethod').value
                                                "
                                            >
                                                <input
                                                    type="radio"
                                                    class="btn-check"
                                                    [value]="opt.value"
                                                    [formControl]="checkControl(item.key, secKey, groupName, i, tabName, j, k).get('tighteningmethod')"
                                                    autocomplete="off"
                                                />
                                                {{ opt.label }}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="row" *ngIf="checkControl(item.key, secKey, groupName, i, tabName, j, k).get('toolid')">
                                    <div class="col-md-4">
                                        <div class="label-wrap">
                                            <mat-label class="font-style" placement="right" container="body" tooltipClass="custom-tooltip">
                                                <!-- Bolt Type -->
                                                Tool Selection
                                            </mat-label>
                                        </div>
                                    </div>
                                    <div class="col-md-8">
                                        <ng-template #boltType_tooltip>
                                            <p>
                                                {{ 'TOOLTIP.INFORMATE_CALC_LABELS.BOLT_TYPE' | transloco }}
                                            </p>
                                        </ng-template>
                                        <mat-select
                                            formControlName="toolid"
                                            class="input-select"
                                            panelClass="input-select"
                                            (selectionChange)="selectedToolChange($event, item.key, secKey, groupName, i, tabName, j, k)"
                                        >
                                            <mat-option class="option-list" *ngFor="let item of calcResult?.output?.tools" [value]="item.id"
                                                >{{ item.manufacturer.name }} - {{ item.name }}</mat-option
                                            >
                                        </mat-select>
                                    </div>
                                </div>
                                <br />
                                <div class="row" *ngIf="tighteningMethod == 0">
                                    <div class="col-md-12" *ngIf="checkControl(item.key, secKey, groupName, i, tabName, j, k).get('torqueapplied')">
                                        <div [formGroup]="checkControl(item.key, secKey, groupName, i, tabName, j, k).get('torqueapplied')">
                                            <div class="table-title">
                                                <h5 class="table-titleh4">Torque Applied</h5>
                                            </div>
                                            <div class="table">
                                                <div class="table-row header">
                                                    <div class="table-cell">Unit</div>
                                                    <ng-container
                                                        *ngIf="
                                                            checkControl(item.key, secKey, groupName, i, tabName, j, k)
                                                                .get('torqueapplied')
                                                                .get('passvalues') as passvalues
                                                        "
                                                    >
                                                        <div *ngFor="let passvalue of passvalues.controls; let i = index" class="table-cell">
                                                            <ng-container *ngIf="passvalue">
                                                                {{ passvalue.get('key')?.value }}
                                                            </ng-container>
                                                        </div>
                                                    </ng-container>
                                                </div>
                                                <div class="table-row">
                                                    <div class="table-cell">
                                                        <mat-select
                                                            [formControlName]="'unit'"
                                                            (selectionChange)="torqueUnitChange($event, item.key, secKey, groupName, i, tabName, j, k)"
                                                            class="input-select"
                                                            panelClass="input-select"
                                                        >
                                                            <mat-option class="option-list" *ngFor="let item of torqueUnitOptions" [value]="item.value">{{
                                                                item.value
                                                            }}</mat-option>
                                                        </mat-select>
                                                    </div>
                                                    <ng-container
                                                        *ngIf="
                                                            checkControl(item.key, secKey, groupName, i, tabName, j, k)
                                                                .get('torqueapplied')
                                                                .get('passvalues') as passvalues
                                                        "
                                                    >
                                                        <div
                                                            *ngFor="let passValue of passvalues.controls; let i = index"
                                                            [formGroup]="passValue"
                                                            class="table-cell"
                                                        >
                                                            <input
                                                                type="text"
                                                                class="input-form-class"
                                                                formControlName="value"
                                                                [class.disable-div]="ToolingValue"
                                                                (keypress)="handleInputEvent($event, 'AllowUnderscoreHypen')"
                                                                (paste)="handleInputEvent($event, 'AllowUnderscoreHypen')"
                                                            />
                                                        </div>
                                                    </ng-container>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row" *ngIf="(tighteningMethod == 0 && selectedTool?.isPowered == true) || tighteningMethod == 1">
                                    <div class="col-md-12">
                                        <div [formGroup]="checkControl(item.key, secKey, groupName, i, tabName, j, k).get('pressureapplied')">
                                            <div class="table-title">
                                                <h5 class="table-titleh4">Pressure Applied</h5>
                                            </div>
                                            <div class="table">
                                                <div class="table-row header">
                                                    <div class="table-cell">Unit</div>
                                                    <ng-container
                                                        [formGroup]="
                                                            checkControl(item.key, secKey, groupName, i, tabName, j, k).get('pressureapplied').get('passvalues')
                                                        "
                                                    >
                                                        <div
                                                            *ngFor="
                                                                let passValue of checkControl(item.key, secKey, groupName, i, tabName, j, k)
                                                                    .get('pressureapplied')
                                                                    .get('passvalues').controls;
                                                                let i = index
                                                            "
                                                            [formGroupName]="i"
                                                            class="table-cell"
                                                        >
                                                            {{ passValue.get('key')?.value }}
                                                        </div>
                                                    </ng-container>
                                                </div>
                                                <div class="table-row">
                                                    <div class="table-cell">
                                                        <mat-select
                                                            class="input-select"
                                                            panelClass="input-select"
                                                            formControlName="unit"
                                                            (selectionChange)="tensionUnitChange($event, item.key, secKey, groupName, i, tabName, j, k)"
                                                        >
                                                            <mat-option class="option-list" *ngFor="let item of TensionUnitOptions" [value]="item.value">{{
                                                                item.value
                                                            }}</mat-option>
                                                        </mat-select>
                                                    </div>
                                                    <ng-container
                                                        [formGroup]="
                                                            checkControl(item.key, secKey, groupName, i, tabName, j, k).get('pressureapplied').get('passvalues')
                                                        "
                                                    >
                                                        <div
                                                            *ngFor="
                                                                let passValue of checkControl(item.key, secKey, groupName, i, tabName, j, k)
                                                                    .get('pressureapplied')
                                                                    .get('passvalues').controls;
                                                                let i = index
                                                            "
                                                            [formGroup]="passValue"
                                                            class="table-cell"
                                                        >
                                                            <input
                                                                type="text"
                                                                class="input-form-class"
                                                                formControlName="value"
                                                                [class.disable-div]="ToolingValue"
                                                                (keypress)="handleInputEvent($event, 'AllowUnderscoreHypen')"
                                                                (paste)="handleInputEvent($event, 'AllowUnderscoreHypen')"
                                                            />
                                                        </div>
                                                    </ng-container>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row" *ngIf="checkControl(item.key, secKey, groupName, i, tabName, j, k).get('toolingvalueas')">
                                    <div class="col-md-4">
                                        <div class="label-wrap">
                                            <mat-label class="font-style" placement="right" container="body" tooltipClass="custom-tooltip">
                                                <!-- Bolt Type -->
                                                Tooling Value As
                                            </mat-label>
                                        </div>
                                    </div>
                                    <div class="col-md-8 d-flex align-items-center">
                                        <mat-checkbox
                                            class="chkToolingValue checkbox-wrap"
                                            color="primary"
                                            (change)="toolValueChecked($event, item.key, secKey, groupName, i, tabName, j, k)"
                                            formControlName="toolingvalueas"
                                            class="checkbox-wrap"
                                        ></mat-checkbox
                                        ><br /><br />
                                    </div>
                                    <p class="error-message" *ngIf="!ToolingValue">
                                        {{ ToolingWarning }}
                                    </p>
                                </div>
                                <div class="row mt-3" *ngIf="checkControl(item.key, secKey, groupName, i, tabName, j, k).get('toolingvalueas')">
                                    <div class="col-md-4">
                                        <div class="label-wrap">
                                            <mat-label class="font-style" placement="right" container="body" tooltipClass="custom-tooltip">
                                                <!-- Bolt Type -->
                                                Bolt Stress
                                            </mat-label>
                                        </div>
                                    </div>
                                    <div class="col-md-8">
                                        <div class="label-wrap">
                                            <mat-label class="font-style" placement="right" container="body" tooltipClass="custom-tooltip">
                                                <!-- Bolt Type -->
                                                {{ resBoltStress }}
                                            </mat-label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </ng-container>
                    <ng-container>
                        <div class="container" style="min-height: 200px; vertical-align: middle; display: flex; justify-content: center; align-items: center">
                            <div class="row flex-column">
                                <div class="col text-center align-items-center">
                                    <span *ngIf="!isJointCalculationAvailable && !isLoading" style="color: red"><b>Joint calculation not available.</b></span>
                                    <span *ngIf="isJointCalculationAvailable && !calcResult?.calculationSucceeded" style="color: red">
                                        <b>Joint calculation not successful.</b>
                                    </span>
                                </div>
                                <div class="col text-center align-items-center">
                                    <ng-container *ngIf="isJointCalculationAvailable && !calcResult?.calculationSucceeded">
                                        <div *ngIf="warningMesaages && warningMesaages.length > 0" style="color: red">
                                            <div *ngFor="let msg of warningMesaages" class="align-self: center;">
                                                <span
                                                    ><b>{{ msg.message }}</b></span
                                                >
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>

                <div class="control-wrapper" *ngSwitchCase="controlTypes.jointidinput">
                    <div class="row" *ngIf="jointIdSetting">
                        <div class="col-md-4">
                            <div class="label-wrap">
                                <mat-label class="font-style">{{ item.alias }}</mat-label>
                            </div>
                        </div>
                        <div class="col-md-8">
                            <!-- {{ jointIdSetting | json }} -->

                            <ng-container *ngIf="jointIdSetting?.userPreference == 'Free Text'">
                                <input
                                    type="text"
                                    class="input-form-class"
                                    matInput
                                    name="{{ item.key }}"
                                    [placeholder]="item?.Placeholder"
                                    [formControlName]="item.key"
                                    [showMaskTyped]="true"
                                    [mask]="item?.maskValue"
                                    [class.disable]="permission != true || AdditionalInfo?.ActivityPackStatus == 'Complete'"
                                    [ngClass]="checkControl(item.key, secKey, groupName, i, tabName, j, k)?.valid ? '' : 'highLight'"
                                    (keypress)="handleInputEvent($event, 'AllowUnderscoreHypen')"
                                    (paste)="handleInputEvent($event, 'AllowUnderscoreHypen')"
                                />
                                <!-- [mask]="item.maskValue" -->
                                <ng-container *ngIf="checkControl(item.key, secKey, groupName, i, tabName, j, k)?.invalid">
                                    <div *ngFor="let val of item.validators">
                                        <p class="error-message" *ngIf="checkControl(item.key, secKey, groupName, i, tabName, j, k).hasError(val.key)">
                                            {{ val.message }}
                                        </p>
                                    </div>
                                </ng-container>
                            </ng-container>

                            <ng-container *ngIf="jointIdSetting?.userPreference == 'Auto-Generate on Ancestory'">
                                <mat-label class="font-style font-italic"
                                    >{{ checkControl(item.key, secKey, groupName, i, tabName, j, k)?.value }} {{ this.JsonDataContent ? '' : '*' }}</mat-label
                                >
                                <input type="hidden" [formControlName]="item.key" />
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</ng-template>
